import { h, Component } from 'preact'
import styled, { css } from 'styled-components'
import LanguageSwitcher from './LanguageSwitcher'
import { HamburgerMenu } from '../../svgs'
import { colors } from '../../../constants'
import { Link } from '../../visual'
import { screenMoreThan930, screenLessThan930 } from '../../media'
import arrows from './arrows.png'
import header from './header.png'
import logo from './logo.png'
import TooltipBubble from '../../TooltipBubble'

const HeaderBar = styled.div`
  height: 104px;
  background: url(${header}) 0 0 repeat-x;
  width: 100%;
  top: 0;
`

const HeaderBarInner = styled.div`
  height: 100px;
  display: flex;
  flex-direction: row;
  max-width: 950px;
  margin: auto;
`

const Spacer = styled.div`
  flex-grow: 1;
`

const Logo = styled.img`
  display: block;
  margin-top: 17px;
  margin-left: 5px;
`

const HamburgerWrapper = styled.div`
  flex-basis: 100px;
  padding: 30px;
  border-left: 1px solid #c8bf4b;
  cursor: pointer;
  ${screenMoreThan930(css`
    display: none;
  `)};
`

const MenuItem = styled(Link)`
  font-size: 20px;
  line-height: 20px;
  border-left: 1px solid #c8bf4b;
  padding: 40px 20px 60px 20px;
`
const MenuItemMobile = MenuItem.extend`
  ${screenMoreThan930(css`
    display: none;
  `)};
`
const MenuItemDesktop = MenuItem.extend`
  ${screenLessThan930(css`
    display: none;
  `)};
`
const MenuItemDesktopSecondaryContainer = MenuItemDesktop.withComponent('div')
  .extend`
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-right: 1px solid #c8bf4b;
`

const MenuItemSecondaryOuter = styled(Link)`
  font-size: 18px;
  margin-left: -5px;
  display: block;
  height: 29px;
  padding: 0;
  :hover {
    color: white;
    background: #32383a;
  }
`
const MenuItemSecondaryInner = styled.div`
  line-height: 27px;
  padding: 0 30px 2px 40px;
  background: url(${arrows}) 4px -7px no-repeat;
  margin: 0;
  :hover {
    background: url(${arrows}) 4px -47px no-repeat;
  }
`
const MenuItemSecondary = props => (
  <MenuItemSecondaryOuter {...props}>
    <MenuItemSecondaryInner>{props.children}</MenuItemSecondaryInner>
  </MenuItemSecondaryOuter>
)

const Dropdown = styled.div`
  opacity: ${props => (props.visible ? 1 : 0)};
  pointer-events: ${props => (props.visible ? 'all' : 'none')};
  background: #32383a;
  line-height: 3em;
  font-size: 20px;
  width: 200px;
  position: absolute;
  top: 100px;
  right: 0;
  transition: opacity 0.2s ease-in-out;
  ${screenMoreThan930(css`
    display: none;
  `)};
`

const DropdownItem = styled.a`
  color: #fff45f;
  text-align: right;
  padding-right: 20px;
  border-bottom: solid 1px ${colors.middleGrey};
  display: block;
`

const Tooltip = styled(({ className }) => (
  <div className={className}>
    <div style={{ display: 'inline-block' }}>
      <TooltipBubble topArrow offset={0.5} width={250} zIndex={500000}>
        Prohlédněte si hodnocení ostatních politiků
      </TooltipBubble>
    </div>
  </div>
))`
  text-align: center;
  opacity: ${props => (props.visible ? 0.7 : 0)};
  pointer-events: ${props => (props.visible ? 'initial' : 'none')};
  transition: opacity 1s ease-in-out;
  z-index: 123456;
`

const HeaderImpl = styled.div`
  position: fixed;
  z-index: 1000;
  width: 100%;
  top: 0;
`

export default class Header extends Component {
  constructor() {
    super()
    this.state = { menu: false, laws: false, tooltip: false }
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({ tooltip: true })
      setTimeout(() => {
        this.setState({ tooltip: false })
      }, 10000)
    }, 3000)
  }
  render() {
    return (
      <HeaderImpl>
        <Dropdown visible={this.state.menu}>
          <DropdownItem href="/cs/zapoj-se">Zapoj se</DropdownItem>
          <DropdownItem href="/cs/o-projektu">O nás</DropdownItem>
          <DropdownItem href="/cs/pro-media">Pro média</DropdownItem>
          <DropdownItem href="/cs/archiv-novinek">Aktuality</DropdownItem>
        </Dropdown>
        <HeaderBar>
          <HeaderBarInner>
            <a href="/cs">
              <Logo src={logo} alt="Rekonstrukce státu" />
            </a>
            <Spacer />
            <MenuItemMobile localhref="/" href="/cs/seznam-politiku">
              Politici
              {this.props.hasTooltip ? (
                <Tooltip visible={this.state.tooltip} />
              ) : null}
            </MenuItemMobile>
            <HamburgerWrapper
              onClick={() => this.setState({ menu: !this.state.menu })}
            >
              <HamburgerMenu />
            </HamburgerWrapper>
            {/* <FullSizeHeader /> */}
            <MenuItemDesktop localhref="/" href="/cs/seznam-politiku">
              Politici
              {this.props.hasTooltip ? (
                <Tooltip visible={this.state.tooltip} />
              ) : null}
            </MenuItemDesktop>
            <MenuItemDesktop
              directhref="/cs/zapoj-se"
              style={{ background: '#8DC641' }}
            >
              Zapoj se
            </MenuItemDesktop>
            <MenuItemDesktopSecondaryContainer>
              <MenuItemSecondary directhref="/cs/o-projektu">
                O nás
              </MenuItemSecondary>
              <MenuItemSecondary directhref="/cs/pro-media">
                Pro média
              </MenuItemSecondary>
              <MenuItemSecondary directhref="/cs/archiv-novinek">
                Aktuality
              </MenuItemSecondary>
            </MenuItemDesktopSecondaryContainer>
          </HeaderBarInner>
        </HeaderBar>

        <LanguageSwitcher />

        <SideMenu />
      </HeaderImpl>
    )
  }
}

const SideMenu = () => (
  <div className="share-nav gt1000">
    <ul>
      <li className="top">
        <a href="#top" className="to-anchor">
          <span>Nahoru</span>
        </a>
      </li>
      <li className="fb">
        <a
          href="http://www.facebook.com/RekonstrukceStatu"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Připoj se na</span>
        </a>
      </li>
      <li className="twitter">
        <a
          href="https://twitter.com/share"
          data-lang="en"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Sdílej na twitteru</span>
        </a>
      </li>
      <li className="mail">
        <a
          className="to-anchor"
          href="#zapojte-se"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Newsletter</span>
        </a>
      </li>
    </ul>
  </div>
)



// WEBPACK FOOTER //
// ./components/layout/Header/index.js